export default __webpack_public_path__ + "static/media/computer-icon.c2b1607d.svg";